/**
 * The one published address, in a module with no dependencies.
 *
 * It used to live in `@/lib/seo`, which is the right place for it and the
 * wrong place to import it FROM: `seo.ts` reads the validated environment,
 * `@/env` validates with zod, and three client components wanted this string —
 * so zod, three hundred kilobytes of it, was in the first-load bundle of every
 * page on the site including `/pl/regulamin`. Lighthouse measured 62 KB
 * transferred and most of it never executed.
 *
 * A constant with no imports cannot drag anything behind it. `@/lib/seo`
 * re-exports it, so nothing that already reads it there has to change.
 */
export const CONTACT_EMAIL = 'kontakt@myflou.pl'
